import { Box, HStack, Text } from "@chakra-ui/react";

export default function ContentSwitcher({value, onChange}) {

    return (
       <div className={'text-center pt-3 p-4'}>
           <Box
               position="relative"
               bg="var(--surface-2)"
               border="1px solid"
               borderColor="var(--border)"
               borderRadius="full"
               display="inline-block"
           >
               {/* Анимированный индикатор */}
               <Box
                   position="absolute"
                   top="2px"
                   bottom="2px"
                   left={value === "PHOTO" ? "2px" : "50%"}
                   w="calc(50% - 2px)"
                   bg="var(--accent)"
                   borderRadius="full"
                   transition="all 0.25s ease"
                   boxShadow="sm"
               />

               <HStack position="relative" gap="0">
                   <SwitcherButton
                       active={value === "PHOTO"}
                       onClick={() => onChange("PHOTO")}
                   >
                       Фото
                   </SwitcherButton>

                   <SwitcherButton
                       active={value === "VIDEO"}
                       onClick={() => onChange("VIDEO")}
                   >
                       Видео
                   </SwitcherButton>
               </HStack>
           </Box>
       </div>
    );
}

function SwitcherButton({ children, active, onClick }) {
    return (
        <Box
            flex="1"
            display="flex"
            alignItems="center"
            justifyContent="center"
            h="38px"
            w="92px"
            cursor="pointer"
            borderRadius="full"
            position="relative"
            zIndex="1"
            onClick={onClick}
        >
            <Text
                fontWeight="600"
                fontSize="sm"
                lineHeight="1"
                m="0"
                color={active ? "var(--accent-contrast)" : "var(--text-muted)"}
                transition="color 0.2s ease"
            >
                {children}
            </Text>
        </Box>
    );
}
